<template>
  <b-container fluid>
    <b-row class="my-3">
      <b-col>
          <p style="text-align: right;">
            &copy; CNCJ {{ new Date().getFullYear() }} - SECURACT : Prise de consentement - 
            <router-link :to="getLegalTermsLink()">Mentions légales</router-link>
          </p>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: "Footer",
  components: {},
  methods: {
    getLegalTermsLink() {
      const routeName = this.$route.name;
      if (routeName && routeName.startsWith('entreprise')) {
        return { name: 'legalTerms', query: { via: 'entreprise' } };
      } else if (routeName && routeName.startsWith('pmca')) {
        return { name: 'legalTerms', query: { via: 'banque' } };
      } else {
        return { name: 'legalTerms' };
      }
    }
  }
};
</script>